import { Component, Input, ElementRef } from '@angular/core';

import { MessageService } from '../../../../core';
import { Cliente } from '../cliente';
import { tiposCondicoesPagamento, isTipoPrazo } from '../../../condicao-pagamento';
import { ClienteTipoPrazoPagamento, ClientePrazoPagamento } from './cliente-prazo-pagamento';
import { ClientePrazoPagamentoSequenciaService } from './services';

@Component({
    selector: 'sgt-cliente-prazo-pagamento',
    templateUrl: './cliente-prazo-pagamento.component.html',
    styleUrls: ['./cliente-prazo-pagamento.component.less']
})
export class ClientePrazoPagamentoComponent {
    /** Se pode editar os dados do form  */
    @Input() canEdit = true;
    /** Se pode editar o tipo de pagamento */
    @Input() canEditTipoPagamento = true;

    @Input() entity: ClienteTipoPrazoPagamento;
    tiposCondicoesPagamento = tiposCondicoesPagamento;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clientePrazoPagamentoSequenciaService: ClientePrazoPagamentoSequenciaService) { }

    /** Verifica se o tipo de pagamento é A Prazo */
    isTipoPagamentoPrazo(): boolean {
        if (!this.entity) {
            return false;
        }
        return isTipoPrazo(this.entity.tipoPagamento);
    }

    onChangeTipoPagamento(tipoPagamento: number) {
        this.entity.tipoPagamento = tipoPagamento;

        // Se for selecionado o tipo de pagamento A Prazo e ainda não tiver nenhum prazo adicionado, então adicionamos o primeiro para o usuário começar a digitar os prazos de pagamento
        if (this.isTipoPagamentoPrazo() && this.entity.prazosPagamento.length === 0) {
            this.insert();
        }
    }

    insert() {
        if (!this.canEdit) {
            this.messageService.info('Sem permissão para inserir um novo prazo', 'Sem permissão');
            return;
        }

        const entityPrazoPagamento = new ClientePrazoPagamento();
        entityPrazoPagamento.sequencia = this.clientePrazoPagamentoSequenciaService.getProximaSequencia(this.entity.prazosPagamento);
        this.entity.prazosPagamento.push(entityPrazoPagamento);
        this.clientePrazoPagamentoSequenciaService.atualizar(this.entity.prazosPagamento);

        setTimeout(() => {
            jQuery(this.el.nativeElement).find(`#prazoPagamento_${entityPrazoPagamento.sequencia}`).focus();
        }, 200);
    }

    delete(index: number) {
        if (!this.canEdit) {
            this.messageService.info('Sem permissão para excluir o prazo', 'Sem permissão');
            return;
        }

        this.messageService.confirm('Deseja realmente excluir esse prazo de pagamento?').then(result => {
            if (result) {
                this.entity.prazosPagamento.splice(index, 1);
                this.clientePrazoPagamentoSequenciaService.atualizar(this.entity.prazosPagamento);
            }
        });
    }

    /** Resolve os prazos de pagamento do cliente */
    resolve() {
        if (!this.entity.prazosPagamento) {
            return;
        }

        if (this.isTipoPagamentoPrazo()) { // A Prazo
            // Removendo os itens do array que não possuirem o prazo informado
            for (let i = this.entity.prazosPagamento.length; i--; ) {
                const entity = this.entity.prazosPagamento[i];
                if (entity.prazo === undefined || entity.prazo == null || isNaN(entity.prazo)) {
                    this.entity.prazosPagamento.splice(i, 1);
                }
            }
            this.clientePrazoPagamentoSequenciaService.atualizar(this.entity.prazosPagamento);
        } else { // Outros
            // Quando não for A Prazo, então removemos todos os prazos que possam ter sido adicionados
            this.entity.prazosPagamento = [];
        }

    }
}
